// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__36pIq","title":"Images45_title__1q1wH","images":"Images45_images__3zEMS"};